__turbopack_context__.v({
  "root": "CartIndicator-module__84bK-q__root",
});
